import React, { useContext, useEffect, useRef, useState } from "react";
import assetsManager from "../assets/assetsmanager/assestsmanager";
import ProfileMenu from "./ProfileMenu";
import { AppContext } from "../context/context";

const NavBar = () => {
  const { state, dispatch } = useContext(AppContext);
  const { activeTab } = state;
  const ref = useRef();
  const [profileMenu, setProfileMenu] = useState(false);

  const tabs = ["ABCD App", "Service App"];

  const handleProfileMenu = () => {
    setProfileMenu((prev) => !prev);
  };

  const handleSetActiveTab = (tab) => {
    dispatch({
      type: "SETACTIVETAB",
      payload: tab
    });
    dispatch({
      type: "SETCTALINKS",
      payload: []
    });
    dispatch({
      type: "SETPROMPTSLIST",
      payload: []
    });
  };

  useClickOutside(ref, () => setProfileMenu(false));

  return (
    <div className="navbar h-full w-full bg-[--primary] flex items-center justify-between px-[2%]">
      <div className="flex w-fit">
        <img className="h-7" src={assetsManager.abcLogo} alt="Logo" />
      </div>
      <div className="flex items-center gap-6">
        <div className="flex gap-3">
          {tabs.map((tab) => (
            <div
              key={tab}
              onClick={() => handleSetActiveTab(tab)}
              className={`${
                activeTab === tab
                  ? "bg-white text-[#C7222A] font-[600]"
                  : "text-white font-[500]"
              } text-sm px-3 py-[0.35rem] rounded w-[6rem] cursor-pointer flex items-center justify-center`}
            >
              {tab}
            </div>
          ))}
        </div>
        {window.location.pathname !== "/admin" && (
          <div ref={ref} className="relative">
            <img
              onClick={handleProfileMenu}
              className="h-full w-full cursor-pointer"
              src={assetsManager.profilePic}
              alt="Profile"
            />
            {profileMenu && (
              <div className="absolute top-[40px] right-[4px]">
                <ProfileMenu setProfileMenu={setProfileMenu} />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default NavBar;

function useClickOutside(ref, onClickOutside) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, onClickOutside]);
}
